import {BrowserRouter, Routes, Route} from 'react-router-dom';
import Begin from './components/Begin';
import Login from './components/Login';
import Splash from './components/Splash';
import SignUp from './components/SignUp';
import Home from './components/Home';
import MovieDescription from './components/MovieDescription';
import Perfil from './components/Perfil';

function App() {
  return (
    <BrowserRouter>
        <Routes>
          <Route path="/" element={<Splash />} />
          <Route path="begin" element={<Begin />}/>
          <Route path="login" element={<Login />}/>
          <Route path="signup" element={<SignUp />}/>
          <Route path="home" element={<Home />} />
          <Route path="movie/:id" element={<MovieDescription />} />
          <Route path="perfil" element={<Perfil />} />
        </Routes>
    </BrowserRouter>
  );
}

export default App;
